import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { renderPageTemplate } from "../../../utils";
import { Default as PageIntro } from "../../partial-templates/page-intro/page-intro.stories";
export default {
    title: "MyTrumpf/Page Templates/Smart Factory",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const TeaserTemplate = () => {
    return html`
        <div class="ux-iws-smart-factory-teaser">
            <div class="ux-iws-smart-factory-teaser__content">
                <div class="ux-iws-smart-factory-teaser__image-wrapper">
                    <img
                        src="mock-assets/images/smart-factory-app-icon.png"
                        alt="Smart Factory App Icon"
                    />
                </div>
                <div class="ux-iws-smart-factory-teaser__text-button-wrapper">
                    <div class="ux-iws-smart-factory-teaser__text-wrapper">
                        <h4
                            class="ux-iws-smart-factory-teaser__intro ux-text-small ux-text-small--bold ux-u-text-uppercase"
                        >
                            Lorem Ipsum
                        </h4>
                        <h5
                            class="ux-iws-smart-factory-teaser__headline ux-text-headline ux-text-headline--big"
                        >
                            Smart view services
                        </h5>
                        <p
                            class="ux-iws-smart-factory-teaser__copy ux-text-normal ux-u-mb-xs"
                        >
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                            elitr, sed diam nonumy eirmod tempor invidunt ut
                            labore.
                        </p>
                    </div>
                    <div class="ux-iws-smart-factory-teaser__button-wrapper">
                        <a
                            class="ux-iws-smart-factory-teaser__button ux-button ux-button--green"
                            href=""
                            >Open</a
                        >
                    </div>
                </div>
            </div>
        </div>
    `;
};

const TeaserInactiveTemplate = () => {
    return html`
        <div class="ux-iws-smart-factory-teaser">
            <div class="ux-iws-smart-factory-teaser__content">
                <div class="ux-iws-smart-factory-teaser__image-wrapper">
                    <img
                        src="mock-assets/images/smart-factory-app-icon.png"
                        alt="Smart Factory App Icon"
                    />
                </div>
                <div class="ux-iws-smart-factory-teaser__text-button-wrapper">
                    <div class="ux-iws-smart-factory-teaser__text-wrapper">
                        <h4
                            class="ux-iws-smart-factory-teaser__intro ux-text-small ux-text-small--bold ux-u-text-uppercase"
                        >
                            Lorem Ipsum
                        </h4>
                        <h5
                            class="ux-iws-smart-factory-teaser__headline ux-text-headline ux-text-headline--big"
                        >
                            Smart view services
                        </h5>
                        <p
                            class="ux-iws-smart-factory-teaser__copy ux-text-normal ux-u-mb-xs"
                        >
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                            elitr, sed diam nonumy eirmod tempor invidunt ut
                            labore.
                        </p>
                    </div>
                    <div
                        class="ux-iws-smart-factory-teaser__button-wrapper ux-iws-smart-factory-teaser__button-wrapper--disabled"
                    >
                        <button
                            class="ux-iws-smart-factory-teaser__button ux-button ux-button--green ux-button--disabled"
                        >
                            Open
                        </button>
                        <div
                            class="ux-iws-smart-factory-teaser__button-wrapper__info"
                        >
                            <ux-icon name="info"></ux-icon>
                            <ux-tooltip
                                tooltip-target="ux-icon[name='info']"
                                align="top"
                            >
                                <div
                                    class="ux-iws-smart-factory-teaser__button-wrapper__info__close"
                                    data-ux-tooltip-close
                                >
                                    <ux-icon name="close"></ux-icon>
                                </div>
                                <div>
                                    <p class="ux-text-normal">
                                        Sie besitzen eine gültige Lizenz für
                                        dieses Produkt. Ihr Zugang ist jedoch
                                        noch nicht eingerichtet. Bitte wenden
                                        Sie sich an den Support, um die App
                                        einzurichten und zu nutzen.
                                    </p>
                                </div>
                            </ux-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};

const contactTeaser = {
    unitHeadline: "Responsible sales unit",
    phone: "T: +49 152 4427217",
    fax: "F: 813156 486 5616",
    email: "M: email@trumpf.com",
    hoursHeadline: "Business hours",
    hours: "Mo-Fr: 09:00 - 18:00",
};

const ContactCardTemplate = () => {
    return html`
        <div class="ux-iws-teaser-contact ux-iws-teaser-contact--unit">
            <div class="ux-iws-teaser-contact__inner">
                <div class="ux-iws-teaser-contact__information">
                    <div class="ux-iws-teaser-contact__image-wrapper">
                        <ux-icon name="avatar"></ux-icon>
                    </div>
                    <div class="ux-iws-teaser-contact__unit-wrapper">
                        <div
                            class="ux-iws-teaser-contact__unit-headline ux-text-tiny ux-u-text-uppercase"
                        >
                            <strong>${contactTeaser.unitHeadline}</strong>
                        </div>
                        <div class="ux-iws-teaser-contact__unit">
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${contactTeaser.phone}</a
                            >
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${contactTeaser.fax}</a
                            >
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${contactTeaser.email}</a
                            >
                        </div>
                        <div class="ux-iws-teaser-contact__unit-mobile">
                            <div class="ux-text-tiny ux-u-text-uppercase">
                                <strong>${contactTeaser.hoursHeadline}</strong>
                            </div>
                            <p class="ux-text-normal">${contactTeaser.hours}</p>
                        </div>
                    </div>
                    <div class="ux-iws-teaser-contact__hours-wrapper">
                        <div class="ux-iws-teaser-contact__hours">
                            <div
                                class="ux-iws-teaser-contact__hours-headline ux-text-tiny ux-u-text-uppercase"
                            >
                                <strong>${contactTeaser.hoursHeadline}</strong>
                            </div>
                            <p class="ux-text-normal">${contactTeaser.hours}</p>
                        </div>
                        <div class="ux-iws-teaser-contact__hours-mobile">
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${contactTeaser.phone}</a
                            >
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${contactTeaser.fax}</a
                            >
                            <a href="#" class="ux-text-link ux-text-link--green"
                                >${contactTeaser.email}</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};

const Template = () => {
    return html`
        <div class="ux-t-container">
            <div class="ux-iws-smart-factory">
                <div class="ux-iws-smart-factory__content ux-u-w-100">
                    ${PageIntro({ headline: "Smart Factory Suite" })}
                    <div class="ux-iws-smart-factory__teaser-wrapper">
                        ${TeaserTemplate()} ${TeaserTemplate()}
                        ${TeaserInactiveTemplate()}
                    </div>
                </div>
                <div class="ux-iws-smart-factory__contact ux-u-w-100">
                    <div
                        class="ux-iws-smart-factory__contact-headline ux-text-headline ux-text-headline--big ux-u-text-align--center"
                    >
                        You need help or want to learn something about Smart
                        Factory ?
                    </div>
                    <div
                        class="ux-iws-smart-factory__contact-subline ux-text-normal ux-u-text-align--center"
                    >
                        <p>We are happy to help you!</p>
                    </div>
                    <div class="ux-iws-smart-factory__card-wrapper">
                        ${ContactCardTemplate()}
                    </div>
                </div>
            </div>
        </div>
    `;
};

const TemplateNoApps = () => {
    return html`
        <div class="ux-t-container">
            <div class="ux-iws-smart-factory">
                <div class="ux-iws-smart-factory__content ux-u-w-100">
                    ${PageIntro({ headline: "Smart Factory Suite" })}
                    <div class="ux-iws-smart-factory__no-apps-wrapper">
                        <ux-icon name="info-rounded"></ux-icon>
                        <div
                            class="ux-iws-smart-factory__no-apps-headline ux-text-headline ux-text-headline--big ux-u-text-align--center"
                        >
                            No Apps.
                        </div>
                        <div
                            class="ux-iws-smart-factory__no-apps-subline ux-text-normal ux-u-text-align--center"
                        >
                            <p>
                                Lorem ipsum dolor sit amet, consetetur
                                sadipscing elitr, sed diam nonumy eirmod tempor
                                invidunt ut labore et dolore magna.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="ux-iws-smart-factory__contact ux-u-w-100">
                    <div
                        class="ux-iws-smart-factory__contact-headline ux-text-headline ux-text-headline--big ux-u-text-align--center"
                    >
                        You need help or want to learn something about Smart
                        Factory ?
                    </div>
                    <div
                        class="ux-iws-smart-factory__contact-subline ux-text-normal ux-u-text-align--center"
                    >
                        <p>We are happy to help you!</p>
                    </div>
                    <div class="ux-iws-smart-factory__card-wrapper">
                        ${ContactCardTemplate()}
                    </div>
                </div>
            </div>
        </div>
    `;
};

export const Default = () => renderPageTemplate(() => Template());
export const NoApps = () => renderPageTemplate(() => TemplateNoApps());
